<template>
  <div v-if="item">
    <div class="row">
      <div class="col-12">
        <ez-input v-model="item.name" :error="errors['name']" required="true">Name</ez-input>
      </div>
    </div>
    <ez-text-area-md v-model="item.description" :error="errors['description']" rows="6">Description</ez-text-area-md>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EzInput from "../shared/_VueEzInput.vue";
import EzTextAreaMd from "../shared/_VueEzTextAreaMd.vue";

export default {
  name: "achievement-form",
  components: {
    EzInput,
    EzTextAreaMd
  },
  props: ["item", "errors"],
  computed: {
    ...mapGetters({
      isAdmin: "isAdmin",
      getOptions: "achievements/getOptions"
    })
  }
};
</script>
